import images from "../../images";
import React from "react";
import Svg from "../Helper/Svg";

const CrossButton = ({ onCancel }) => {
  if (!onCancel) {
    return null;
  }

  return (
    <button className="absolute right-4 top-3" onClick={(event) => onCancel(event)}>
      <Svg icon={images.icons.cross} />
    </button>
  );
};

export default CrossButton;
